import { configureStore } from "@reduxjs/toolkit";

import userReducer from "./userSlice";
import processReducer from "./processSlice";
import partyReducer from "./partySlice";
import empReducer from "./empSlice";
import empworkReducer from "./empworkSlice";
import paymentReducer from "./paymentSlice";
import billReducer from "./billSlice";
// In forntend/src/redux/store.js
import workEntryReducer from "./workEntrySlice";


const store = configureStore({
  reducer: {
    user: userReducer,
    process: processReducer,
    party: partyReducer,
    emp: empReducer,
    empwork: empworkReducer,
    payment: paymentReducer,
    bill: billReducer,
    workEntry: workEntryReducer,
  }
});

export default store;
